const KEY = 'playground-partner-signin-email'

/**
 * The address the magic link was requested for.
 *
 * Firebase does not put it in the link — the client must supply it, and that
 * is what stops a stolen link being redeemed elsewhere. So a link only
 * completes in the browser that asked for it.
 */
export const readPendingEmail = (): string | null =>
  window.localStorage.getItem(KEY)

export const writePendingEmail = (email: string): void =>
  window.localStorage.setItem(KEY, email)

export const clearPendingEmail = (): void => window.localStorage.removeItem(KEY)
